import { Select, Typography } from '../../components/primitives';
import { Iconography } from '../../components/primitives/Iconography';
import { useProjectsContext } from '../../context/projects.context';
import { testId } from '../../utils';
import { ProjectFilter, ProjectSort } from '../../utils/project/project-filter';
import { useTranslation } from '@rpi/i18n';
import { useCallback } from 'react';

interface FilterSectionProps {
  pageRange: string | null;
  setPageIndex: (page: number) => void;
}

export const FilterSection = ({
  pageRange,
  setPageIndex,
}: FilterSectionProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'route.project-filter',
  });
  const {
    selectedSort,
    setSelectedSort,
    sortingOptionsList,
    selectedFilter,
    setSelectedFilter,
    filterOptionsList,
  } = useProjectsContext();

  const sortChange = useCallback(
    (value: string) => {
      setSelectedSort(value as ProjectSort);
      setPageIndex(0);
    },
    [setPageIndex, setSelectedSort],
  );

  const filterChange = useCallback(
    (value: string) => {
      setSelectedFilter(value as ProjectFilter);
      setPageIndex(0);
    },
    [setPageIndex, setSelectedFilter],
  );

  return (
    <div className="flex md:gap-10">
      <div className="flex flex-col w-full md:flex-row md:flex-grow gap-6">
        <div className=" md:min-w-80">
          <div className="flex">
            <Iconography variant="filter_list" className="text-base" />
            <Typography
              variant="form-label"
              className="justify-center"
              {...testId('current-value')}
            >
              {t('sortBy')}
            </Typography>
          </div>
          {
            <Select
              data={sortingOptionsList}
              value={selectedSort}
              onChange={sortChange}
              {...testId('project-sort-dropdown')}
            />
          }
        </div>
        <div className="md:min-w-80">
          <div className="flex">
            <Iconography variant="filter_alt" className="text-base" />
            <Typography variant="form-label" {...testId('current-value')}>
              {t('filter')}
            </Typography>
          </div>
          {
            <Select
              data={filterOptionsList}
              value={selectedFilter}
              onChange={filterChange}
              {...testId('project-filter-dropdown')}
            />
          }
        </div>
      </div>
      <div className="md:min-w-24">
        <Typography
          variant="body"
          className="hidden md:flex items-center h-full text-left"
          {...testId('page-range')}
        >
          {pageRange}
        </Typography>
      </div>
    </div>
  );
};
